import SectionHeader from './primitives/SectionHeader';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  title: string;
};

function UserInfoSection({ children, title }: Props) {
  return (
    <>
      <SectionHeader data-test="section-header">{title}</SectionHeader>
      {children}
    </>
  );
}

export default UserInfoSection;
